import { connect } from 'react-redux';
import { IState } from '../../../../../../store/types';
import { getBookSettings, isBookRegenerating } from '../../../../../../store/books/selectors';
import { BookSettingsForm } from '../components/BookSettingsForm';
import { IBookSettingsFormEvents, IBookSettingsFormFields, IBookSettingsFormOwnProps } from '../components/types';
import { BookSettingsFormEvents } from './events';
import { getBookLangOptions } from './getBookLangOptions';

const mapStateToProps = (
	state: IState,
	{ bookId }: IBookSettingsFormOwnProps
): IBookSettingsFormFields => ({
	settings: getBookSettings(state, bookId),
	regenerating: isBookRegenerating(state, bookId),
	langOptions: getBookLangOptions(state),
});

const mapDispatchToProps = (
	dispatch: any,
	{ bookId }: IBookSettingsFormOwnProps
): IBookSettingsFormEvents => ({
	onRegenerate: (settings) => dispatch(BookSettingsFormEvents.onRegenerate(bookId, settings)),
	onChangeTranslationLang: (nativeLang) => dispatch(BookSettingsFormEvents.onChangeTranslationLang(bookId, nativeLang)),
});

export const BookSettingsFormHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(BookSettingsForm);

BookSettingsFormHOC.displayName = 'BookSettingsFormHOC';
